import Dialog from '@mui/material/Dialog';
import React from 'react';
import { TimeslotEffectOptions } from 'shared/types/timeslot';

import { UpdateTaskRepeatTimeslotMessage } from './update-task-repeat-timeslot-message';

export type DeleteHabitDialogProps = {
  open: boolean;
  onSubmit: (timeslotEffect: TimeslotEffectOptions) => void;
};

export const UpdateTaskRepeatTimeslotDialog: React.FC<
  DeleteHabitDialogProps
> = ({ open, onSubmit }) => {
  const onClose = () => onSubmit(TimeslotEffectOptions.Cancel);
  const onSubmitSingle = () => onSubmit(TimeslotEffectOptions.SingleOccurrence);
  const onSubmitAll = () => onSubmit(TimeslotEffectOptions.AllOccurrences);

  return (
    <Dialog open={open} fullWidth onClose={onClose}>
      <UpdateTaskRepeatTimeslotMessage
        onSingle={onSubmitSingle}
        onAll={onSubmitAll}
        onCancel={onClose}
      />
    </Dialog>
  );
};
